module.exports = __webpack_public_path__ + "static/img/3_2.ef6c082c.jpg";